import { observable, makeObservable, makeAutoObservable } from 'mobx';
import _ from 'lodash';
import {DomainObject, DomainStore} from 'shared/store';
import {api} from 'shared/core';
import {endpoints, types} from 'main/tools';
import Company from 'main/stores/users/Company';

class SignUpForm extends DomainObject {
  firstName;
  lastName;
  email;
  emailConfirmation;
  password;
  termsAccepted = false;
  company;

  _relations = {
    company: Company
  };

  constructor(other) {
    super();

    makeObservable(this, {
      firstName: observable,
      lastName: observable,
      email: observable,
      emailConfirmation: observable,
      password: observable,
      termsAccepted: observable,
      company: observable
    });

    this.merge(other);
  }
}

class SignUpState {
  store = new DomainStore();
  redirectUrl;

  form = new SignUpForm();
  settingUp = false;
  errors = {};
  isSlim;
  showBackLink;

  constructor({demoAccount, isSlim, redirectUrl, showBackLink}) {
    makeAutoObservable(this, {
      store: false
    });

    this.form.merge({
      company: {
        demoAccount
      }
    });

    this.isSlim = isSlim;
    this.redirectUrl = redirectUrl;
    this.showBackLink = showBackLink;
  }

  async submitForm() {
    const {model, errors} = await this.store.post(
      endpoints.USERS.ALL,
      types.USER,
      this.form
    );

    if (_.isEmpty(errors)) {
      this.form.merge(model);

      if (this.form.company.demoAccount) {
        this.settingUp = true;
        await this.setupDemoData();
      }

      this.redirectToPlatform();
    }

    this.errors = errors;
  }

  async changeForm(partialForm) {
    this.form.merge(partialForm);
  }

  async setupDemoData() {
    await api.post('/setup_accounts');
  }

  redirectToPlatform() {
    window.location = this.redirectUrl || '/';
  }
}

export default SignUpState;
